<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX19PZAFjecDwhZV1CDCJJ2nPf9VnSFYauo0=",
          "cpf": "U2FsdGVkX19PAo97l0IfFP/CWlPz/wltk7XrtRpN0co="
        }, {
          "num_cand": "U2FsdGVkX1+vsyWu8Lm5UA33Li+FgeC1RCyEcWEHLGo=",
          "cpf": "U2FsdGVkX18GVX5F+dtk3o4gEjESv3yEd5AfuX9nWik="
        }, {
          "num_cand": "U2FsdGVkX1+s22scpq5KJc6eZSVt6MpT2Cvknzu78ls=",
          "cpf": "U2FsdGVkX18Jz+lV+A0UEco7Sqx97Y6txu32kFRTOQM="
        }, {
          "num_cand": "U2FsdGVkX18OVEjo+PdHS+Ydf9JGZTr7lxFuP/kjrbg=",
          "cpf": "U2FsdGVkX18YWYso/53F/k9OAMGNxWL9G6QZFDwR/Os="
        }, {
          "num_cand": "U2FsdGVkX1/ymnbnA0dbHPtX1P1BGBbuM/JsP/aRICk=",
          "cpf": "U2FsdGVkX19JsBEjUaC/apI8a2OlaiVSnB0At/IDC3E="
        }, {
          "num_cand": "U2FsdGVkX1/jDciXLzjgQxoNy1fodDEPT9fxgml7LRQ=",
          "cpf": "U2FsdGVkX1+8ozjVgZbmc/JBXSmGUZurwIh1ai2Tzpc="
        }, {
          "num_cand": "U2FsdGVkX1/TEQN/i7zJy8LSE8Qf3rju2wxpRQcA//4=",
          "cpf": "U2FsdGVkX1/il/i3EgA7xO5wKUu7GM3dl8Pg292vTgI="
        }, {
          "num_cand": "U2FsdGVkX18p9RqtNM3wuk9HwsDBlQeYQr5FykBJXWo=",
          "cpf": "U2FsdGVkX1/s4juJAeQvwWU4Mp7rBKRuL9iGOeXUU3s="
        }, {
          "num_cand": "U2FsdGVkX18O/8LK0TdSysC5XjYM4Wlx8Ti900Es3Qc=",
          "cpf": "U2FsdGVkX18fW1AdsVZU7ukUA9b7zZg1cE6s0Ln9dNM="
        }, {
          "num_cand": "U2FsdGVkX1/4voq+ErypxCXGWyKPr6D+6k09eeXbvig=",
          "cpf": "U2FsdGVkX1/6H4j1m8l6L6eUxw8dU8cJBpiNkH3hmYc="
        }, {
          "num_cand": "U2FsdGVkX182cqvvtLAklcwh201JbiQIJSSn8/QzGqM=",
          "cpf": "U2FsdGVkX1+/EqdBkneop/b5JuFVvq95DyV4pSiV+Tk="
        }, {
          "num_cand": "U2FsdGVkX1/DDqHxes6Myk/u81f5wMOtEK6X/oB02MU=",
          "cpf": "U2FsdGVkX1++bVr4R8DASmAUYJFMrmII7dMTMuf2tls="
        }, {
          "num_cand": "U2FsdGVkX190X25saURc2cld+hu9Xh06KnqaT7U/U1U=",
          "cpf": "U2FsdGVkX1+m9IWoQpi0VGnjM+aUvXbo3+Og4JCBS8E="
        }, {
          "num_cand": "U2FsdGVkX18tbYQbsvzRy1My25GxdwoyDvtJqjy2Who=",
          "cpf": "U2FsdGVkX1+c4LFbjqygmteEFVouiAOR+KF+/bdHhz4="
        }, {
          "num_cand": "U2FsdGVkX18mZGLnIYkOElRcihKPmpIFyPWs4cp2m4U=",
          "cpf": "U2FsdGVkX1/frV5Sa0VrpV5KlZporaxW7vNXCFs9eGo="
        }, {
          "num_cand": "U2FsdGVkX1/4mK6iLBYHnpyMH3btytZ/QsGfIM+Sej8=",
          "cpf": "U2FsdGVkX1+dq8tCsPxm1TuQVJqbP6fcCHunHHI6Lz4="
        }, {
          "num_cand": "U2FsdGVkX19nxj3ueBlm6wzrrKtigTVwtHiF4XPY4As=",
          "cpf": "U2FsdGVkX18OxaZR4mLUhJxOD68qIT0taRPtscyddf0="
        }, {
          "num_cand": "U2FsdGVkX19SOcYs96A9VRu46+cegq/0PErzhBUQm00=",
          "cpf": "U2FsdGVkX1/v8Y8RHaaiC4MjyLXPFLhavUm5YQXjIUM="
        }, {
          "num_cand": "U2FsdGVkX19kwdjcB1yDj6E7dIM/PimM95yZJTNkhXQ=",
          "cpf": "U2FsdGVkX1/kuPIAoUjicl9n0FJAx1R1zym9gdTzJic="
        }, {
          "num_cand": "U2FsdGVkX18QVpUPgMshtKNBv4wGeTuyP+szbmNht0U=",
          "cpf": "U2FsdGVkX188DBs62gYAW/89lPTfN3jrVj9Oc//J4k4="
        }, {
          "num_cand": "U2FsdGVkX18l0Ng1SZqyv0sYltti2L+bh+HOGB+N7AM=",
          "cpf": "U2FsdGVkX19AyuOcSOuViVY9i79Ve1YjPDwFJKPbcuQ="
        }, {
          "num_cand": "U2FsdGVkX19nWetB5YORNM8pelV/DJSVVKtQEB/eT/Q=",
          "cpf": "U2FsdGVkX19u4tZs2PGrU+iEw8Jk5iLJylsHxHHM1tk="
        }, {
          "num_cand": "U2FsdGVkX19zYCIVgRWdawsvBByfG8jpgR7u9PXihp4=",
          "cpf": "U2FsdGVkX1/BzlnXDaMtx6oZLwCrxamLrtBE0ZVcouQ="
        }, {
          "num_cand": "U2FsdGVkX184OiASu0LE3Zgsv74DLr051hmpjSJy8lI=",
          "cpf": "U2FsdGVkX1819g4bqaUY3vqOn4EcOpCH8FuZoiKncJA="
        }, {
          "num_cand": "U2FsdGVkX19XJJmnUXGBqOODhXRlNxiWQlW7saw/Zrk=",
          "cpf": "U2FsdGVkX18BY1Hbj3C2jZ4dN3Ak8sMHteTeRUDY19w="
        }, {
          "num_cand": "U2FsdGVkX197DsRFunMR3PWGHHulS151tQRYLFEU7rs=",
          "cpf": "U2FsdGVkX19LQ4nVp6yYYf5A07GuAXJW5PiQfTPjpOo="
        }, {
          "num_cand": "U2FsdGVkX19zU/tNxkp8zAGlzKZnwb4yk8JnGAtJ+F0=",
          "cpf": "U2FsdGVkX19LRoKtfd7XGBzSVaEtQwMvAmn3xeWDK5c="
        }, {
          "num_cand": "U2FsdGVkX1+0sTHNu+3VZhYY3McLUNjtQOWyRRO/aGM=",
          "cpf": "U2FsdGVkX18M0M1B2j1TQVU3hTlvbfgz1GM9wj6oV0c="
        }, {
          "num_cand": "U2FsdGVkX19xJBLC/dtUGok9aZ4IEAPzKiltit6KUKQ=",
          "cpf": "U2FsdGVkX19jZriISxsW1D7Qv5iShLGQjlzCapirnFI="
        }, {
          "num_cand": "U2FsdGVkX1/l8pY6ZPs7d0Y+qNz69a9+qYzE32Ytklc=",
          "cpf": "U2FsdGVkX18xaWMDQgCIh52L3llWXv3drj3ChTL0lUs="
        }, {
          "num_cand": "U2FsdGVkX1+sHiLjOuGLxKn4NALIqwadZtsY5Pdpcrw=",
          "cpf": "U2FsdGVkX1+Hwkqgr4aiXeQkC5QnWLhfTtC6vyX4t5I="
        }, {
          "num_cand": "U2FsdGVkX19/hgNpAQcpsQykw0nHvtgKyjn+ufuyOcw=",
          "cpf": "U2FsdGVkX18kCqRR0tgS/Icb6bzkmd434fz39wjoeDI="
        }, {
          "num_cand": "U2FsdGVkX19IZsdP6+z36YuBMesTwHHLEjTHwBceN9M=",
          "cpf": "U2FsdGVkX1/5dl7RMhF2jjLWgKHtOvOeelMpOoxEzWw="
        }, {
          "num_cand": "U2FsdGVkX194v1hd1fcUbKJpN1HperEtvAy1fdsKs1c=",
          "cpf": "U2FsdGVkX18fNNAQPu/gIinxoLKhD/tNK9dihrR1zg8="
        }, {
          "num_cand": "U2FsdGVkX19ryhFpeiKP6B0alZPKfT6ZucTNu9HecGU=",
          "cpf": "U2FsdGVkX19d0bc2ePSFOvaHQ+l0w5EnaBdHy1KSeWM="
        }, {
          "num_cand": "U2FsdGVkX18qSVknNuIhGKmG1sfILViKh/En+h3tWso=",
          "cpf": "U2FsdGVkX19Qj6luyogxZm8VvYD9zaQAEdpUeoqB7QI="
        }, {
          "num_cand": "U2FsdGVkX19IhGeTg9CGeOZxz16MrTCyZynT+yXHKtk=",
          "cpf": "U2FsdGVkX1+aclSGEHVekW6nLrV3f/vBO/uJosYB6L0="
        }, {
          "num_cand": "U2FsdGVkX19jdUjXkfLJ/n4Hbwa7XC7eHsp3ANqibXM=",
          "cpf": "U2FsdGVkX1+Klm4QpgOLtW8ZUzMfaVwc6vkfY48IVP4="
        }, {
          "num_cand": "U2FsdGVkX19dfg5qYcnvtdipt81tfgGjIkuHQ2Aprtw=",
          "cpf": "U2FsdGVkX19LhQ0tSfVitSPfH6EigJOl7ckVNAO1HRs="
        }, {
          "num_cand": "U2FsdGVkX1+XwY7VjT25ZmzsGkeLmQVuLMXVIiQjSXI=",
          "cpf": "U2FsdGVkX19XQMWM5XEIlOyPaHWY+BfciIG6m3bbP94="
        }, {
          "num_cand": "U2FsdGVkX198/py1Hq6YVXXc0WXlfJYqtNejJ7cGMd0=",
          "cpf": "U2FsdGVkX19L7EJ92KRhKxnIbs12aOXRvQGnGL+ogtQ="
        }, {
          "num_cand": "U2FsdGVkX193qYuT6HEYJNytJ6pmkktyElyF9qZC6DI=",
          "cpf": "U2FsdGVkX19MCcWvKpfT/JoRqAUCeqUk9p/hlZgu/vk="
        }, {
          "num_cand": "U2FsdGVkX18sSZ42Rn2mFOLguVahSf320TArN6xDphg=",
          "cpf": "U2FsdGVkX1/fF4voufL3NxBpy1OqfL+ZuURWKWsOR3o="
        }, {
          "num_cand": "U2FsdGVkX1+F5pGvtd0VqEKi/ZNBmVyHXdif34fVZ7Q=",
          "cpf": "U2FsdGVkX1/OMCVv991gEjt3T0SMz9p+5DZeykmHXRw="
        }, {
          "num_cand": "U2FsdGVkX1+B0ppmaTKj/KIy7zAEsoGmISEGhmShfro=",
          "cpf": "U2FsdGVkX18ww3utYW1r0EjJlW7zZRUUCDUI0BRYuC4="
        }, {
          "num_cand": "U2FsdGVkX19gF7hlePpOFwv+MUtfaJH/vS7IXz/PCoI=",
          "cpf": "U2FsdGVkX19XbGshUVBfDzQ8GviEdw3nZvb/9yyUUCE="
        }, {
          "num_cand": "U2FsdGVkX1/w4ji6qIGEcmkdbC/j1dlICfGGUF3OX9c=",
          "cpf": "U2FsdGVkX19pVJafW5bZFH1wXpXaI3O2jhnvFpKFYQU="
        }, {
          "num_cand": "U2FsdGVkX1/r7tjcKRhn0gqaaRg12AvF9uTIOT8IWrE=",
          "cpf": "U2FsdGVkX19WYgrTL5WB4JiEt+XGySqkgaO4/NewGJI="
        }, {
          "num_cand": "U2FsdGVkX18JWFMEdK1YDwJ57+HQEe7UDQZ34EJKAKU=",
          "cpf": "U2FsdGVkX1+UgTuIfxom+4lHSSyLClVhHiYcF0NK7jE="
        }, {
          "num_cand": "U2FsdGVkX1/qrX6YhPRWZjllVXT+0vNISgflQXdQVeI=",
          "cpf": "U2FsdGVkX19Wtw/Z13XEOdSsch1jzgmEMGRIxeVk8Cc="
        }, {
          "num_cand": "U2FsdGVkX18MhbQRPQa2GGJ0XYiPMfM5OqW2VRaS1sI=",
          "cpf": "U2FsdGVkX183uRwNdPjypEJW6hr0ovS96q7uuyprAlE="
        }, {
          "num_cand": "U2FsdGVkX19k7ClYmxPLR9GljUonp7VuQGg975wafjU=",
          "cpf": "U2FsdGVkX1/u6CROJ30b2hxIUeRbp8rco9d/2uzetDc="
        }, {
          "num_cand": "U2FsdGVkX1+UkaLn7PiHG1xAtSkwq1Flb6/HWLTITCs=",
          "cpf": "U2FsdGVkX19lalz3bp2iZ2BYpDpPQkK8BP90Wx1z0hM="
        }, {
          "num_cand": "U2FsdGVkX18cvbNo7QNjgKoW7jBIyvUUgvVl5+ajsV4=",
          "cpf": "U2FsdGVkX18+0HdOQMRREW6ZaTPp8YeGH3KcsmuTLE8="
        }, {
          "num_cand": "U2FsdGVkX19IYEcnnXoyVVTC3SDqx5mAiJQTJPJzboI=",
          "cpf": "U2FsdGVkX18TOrxXtwDewBlAA0JhzpmJbAcX/6GaqMk="
        }, {
          "num_cand": "U2FsdGVkX189X/gpo5KSSutQZk9gpzffQ2LL6n9vJZI=",
          "cpf": "U2FsdGVkX1+ufKOy8NN7prYewDpsPFCiT47zknesdkk="
        }, {
          "num_cand": "U2FsdGVkX19jbuGDcgoMpAN9UuiGYIsWR9N93HL39sI=",
          "cpf": "U2FsdGVkX1+cd4Oo50XGfxccf1O+au0gI3zicfnxOKQ="
        }, {
          "num_cand": "U2FsdGVkX1+ibqbN/SGORxOJWjIWUqzOfTBa1FtG0dY=",
          "cpf": "U2FsdGVkX1/J3sOJ5G/wsFhVyfHJt6NBtI+iLqvBKYg="
        }, {
          "num_cand": "U2FsdGVkX18kFk8ioQwvRFMLhh1lio6WPdEjniBG50c=",
          "cpf": "U2FsdGVkX1/cyo5JR4PnM3iaofNiyGTx3WQ/p1Wz6cA="
        }, {
          "num_cand": "U2FsdGVkX19FPoFSMO0efrTgfMrC2sEpzth4Ac86MdM=",
          "cpf": "U2FsdGVkX19xB3c6w6dPXT765ikGN4qY/7Naccmhdns="
        }, {
          "num_cand": "U2FsdGVkX18jehj0FRJbiD5ioA2cwzvCPpHi0eyuitw=",
          "cpf": "U2FsdGVkX1+GbGxgYzMW/82aMgRPa8hmQV2psFC/aJM="
        }, {
          "num_cand": "U2FsdGVkX1+cVjdIuDp4R6rMll4GiUlwSzljZG651b4=",
          "cpf": "U2FsdGVkX1+gkSYDUoVJUoF521TfQdv9ehpW8NQfAEs="
        }, {
          "num_cand": "U2FsdGVkX196zoCcEOj1xUyQ1BQKusymiTS7JV66i68=",
          "cpf": "U2FsdGVkX19Y6VrY53n9QX5CfQ/R/CcT+rz8+T1oRfo="
        }, {
          "num_cand": "U2FsdGVkX18lYBBxn5vgkNrC024UJH2yx25sjasS/38=",
          "cpf": "U2FsdGVkX18PTSwag5RFuCepHh4gAtF9LwiV3JFXnd0="
        }, {
          "num_cand": "U2FsdGVkX1/BqXlWtdx6NPuFP086RaHAwd1Why0Ktrg=",
          "cpf": "U2FsdGVkX1+yM+wQXAsY/26YPETpSKuBhhKE3bDE9PY="
        }, {
          "num_cand": "U2FsdGVkX1/lvvnOUhUSpaUrwfzRh19DK+qQIrT/jws=",
          "cpf": "U2FsdGVkX18znYbWwcpa0GXDxLmMOTnFdXmyb+4pZB8="
        }, {
          "num_cand": "U2FsdGVkX1+yMyBJCQ5dJr01zKwdeTVCvk34JJQAHSI=",
          "cpf": "U2FsdGVkX19VD8Iabnw0CVSgz0yaddD0Z03vqyJlgAQ="
        }, {
          "num_cand": "U2FsdGVkX1+BGPU1BwsGGA+5Wcmf73hznuzQky/RZQQ=",
          "cpf": "U2FsdGVkX18ILjKKAIKh8eR3h8C3btNV12mDYvERGrw="
        }, {
          "num_cand": "U2FsdGVkX18LH9vualNW2hXvjuZQgfBiMCl60g/5auE=",
          "cpf": "U2FsdGVkX19narlcFjv+OmA/cxk5MiDxNqsHBrR66k8="
        }, {
          "num_cand": "U2FsdGVkX18gnszeiqS4gqLIzZFBgi4ftmtbUqvL8c8=",
          "cpf": "U2FsdGVkX1+RbI+rx0d/tpgnjgjXZARxZJVmYEjtOaU="
        }, {
          "num_cand": "U2FsdGVkX1/P5tIGewH1QSv/MNLyve901dFgVuXj/aY=",
          "cpf": "U2FsdGVkX1/hcU2s4va24+LsIaNjSliiK2jaM1Aels0="
        }, {
          "num_cand": "U2FsdGVkX19DV+SGzsjwKdid7ub+h2ziXCTi5mvop6M=",
          "cpf": "U2FsdGVkX1+JlV4Y9eY9MBdVjOKilv2GU0gX6SIZeBY="
        }, {
          "num_cand": "U2FsdGVkX1+G8XFdK/H8UO8AkP+jMgjDMzgUoxnamuY=",
          "cpf": "U2FsdGVkX1/uU/k17PsQk+qoUwZTYXDwCuLWJ8+UESQ="
        }, {
          "num_cand": "U2FsdGVkX1/T2sQn7UlOOzzYGoT5J+F4qPAI5uL97XU=",
          "cpf": "U2FsdGVkX1/MW4CDyyGWqE8BB5fnhChS6XaJRImFVvY="
        }, {
          "num_cand": "U2FsdGVkX1/xuAkbYx8Dzn5rjKG/sFNcm+PcQIBAVbc=",
          "cpf": "U2FsdGVkX190SX5ZADEFlF4XVVpCDvxNGkvUFkv+2vI="
        }, {
          "num_cand": "U2FsdGVkX1/reTIl1vQqguCfcoqVxy57d13CrW/RCH0=",
          "cpf": "U2FsdGVkX184NUM2cMrM/rpQYJYZJDCoo0nwkyxO0Jg="
        }, {
          "num_cand": "U2FsdGVkX1+G2cdlyNyMvppKHhTixL3MKLr9Q1oA6PA=",
          "cpf": "U2FsdGVkX1+s3g3yi79k8s+C4ehxse/cUoqvvI99GDI="
        }, {
          "num_cand": "U2FsdGVkX18BT4nxdqaUDZ7CIS9hyRT830H6IwUki58=",
          "cpf": "U2FsdGVkX1/AhXyB1tJf3s17LkjhPz2JQ0sL6bu8Ffk="
        }, {
          "num_cand": "U2FsdGVkX18J+rq6WNd9P3BmZTea2qW7TXdnhqF7YeY=",
          "cpf": "U2FsdGVkX18i0MTMZlx2yU9ktRTDQ9VUrRqv+DftXKA="
        }, {
          "num_cand": "U2FsdGVkX1+m+9OBtPbm9izhVG/fyw4nKf20JxdcBV4=",
          "cpf": "U2FsdGVkX18/EO3Pl5t7Z3RaRSlQxar9p8kIvnpkB9I="
        }, {
          "num_cand": "U2FsdGVkX19BZbr+lvS3/PCjcHY8Kyqq7sVli9spcJk=",
          "cpf": "U2FsdGVkX19BiClwogeHVnJpqhiQcztz7SEhUQlPeaA="
        }, {
          "num_cand": "U2FsdGVkX1/dHIO0YkBB61mQWdjdyDzu0HLSixquowE=",
          "cpf": "U2FsdGVkX19CyocFjkrusGaZ4N+qAAWJv71FrZzIy50="
        }, {
          "num_cand": "U2FsdGVkX1+FykKQRzd+orb/k4yb/2ABt8ZjpsWwf1k=",
          "cpf": "U2FsdGVkX18YIld7A4w4WNZErohX0oJhdu4PdWOM9G4="
        }, {
          "num_cand": "U2FsdGVkX18NvUNu/Fwo+ozNmEJXRa+z3w4dN1DOLRs=",
          "cpf": "U2FsdGVkX19hfAFBxL/fdquO8oJ9CPR6aUA9WeSdK6I="
        }, {
          "num_cand": "U2FsdGVkX1+y+62MjFuedL2KKYzPSSBV0IE/YOphFfY=",
          "cpf": "U2FsdGVkX18T5/IvptWxfO3av4hDQNDpV7KbSMV3cU4="
        }, {
          "num_cand": "U2FsdGVkX1/sTpTvwoDY31hpHxYZxctwb/2SqzRQCE4=",
          "cpf": "U2FsdGVkX1/4Pa9WjaMvAsfBlxQB1pkQBMvCDnNR2kc="
        }, {
          "num_cand": "U2FsdGVkX1+VIIGcaoeJTzlm8e9JEqfqwomCrJsRVuM=",
          "cpf": "U2FsdGVkX1/fNAuZGhV7XkLpwIWTwEOycZ2oUyOV4h0="
        }, {
          "num_cand": "U2FsdGVkX1944KBTA0LK+KK/4lei2JD9Cat1wO0MMbM=",
          "cpf": "U2FsdGVkX1/xGa3wMDF6JhqzL3elNimYFljw1Lvn1N4="
        }, {
          "num_cand": "U2FsdGVkX18ECj3BMhtmKtMnrcOZcmrodzcsxGXSy64=",
          "cpf": "U2FsdGVkX1+X696pLZkE/X/tQpaK5zj1C0jnQXMpKGA="
        }, {
          "num_cand": "U2FsdGVkX1+sBRzut7kswfGjtne4IStrIAcpK49udCc=",
          "cpf": "U2FsdGVkX19TzjcbluHABmC+A1TQQiZzDnp51P9ZwMg="
        }, {
          "num_cand": "U2FsdGVkX1/4dGOZi8YxYk8K9/3HCFLAP9o9TzeNWAc=",
          "cpf": "U2FsdGVkX1/Dmj5YWW6spy+NSE9Ys8dLapTlgM9aX3o="
        }, {
          "num_cand": "U2FsdGVkX1+/DJILrpCGzG/O13kHPIqkmentbBfMu7w=",
          "cpf": "U2FsdGVkX1+0bhKbBvM1sBLu+LfEZekfBoXAyW2GCkQ="
        }, {
          "num_cand": "U2FsdGVkX1+CudUe8rF+uROoW9nIB/geWIvyscRhsy8=",
          "cpf": "U2FsdGVkX1+oNJpIKzcNvMVdHP4dW49CdWY+AJl115g="
        }, {
          "num_cand": "U2FsdGVkX196JvpCcLzjLfPrmx1Ak/W/KtqoaewRXxA=",
          "cpf": "U2FsdGVkX1/QGgUzJXyZyx6iJdqIjEHQzjGyOo7klQM="
        }, {
          "num_cand": "U2FsdGVkX18GzICl5vI3GgewET76EFJSRF1pMbzUBRg=",
          "cpf": "U2FsdGVkX19lI2nShlPOADdMTJyCcXcjqFQALjQFkWQ="
        }, {
          "num_cand": "U2FsdGVkX19hpYttzgMsnO+QoFrRtH2wUSpNz/w5+Ms=",
          "cpf": "U2FsdGVkX19a/J8ylpSTjWIHmu5655vytf9449vKUiw="
        }, {
          "num_cand": "U2FsdGVkX1+aVfgC8dfUnkD/IHLgfDYin3s38Bxe840=",
          "cpf": "U2FsdGVkX1+W68geYGUqOFU9OR07SWOOvLjrrtEWeQs="
        }, {
          "num_cand": "U2FsdGVkX18m97fzkNt6TA5YyOb5DcS06+tYqEUPyT0=",
          "cpf": "U2FsdGVkX1/KLFAKkN2gDfsE+JWiKy5OG6JvI8/8M8I="
        }, {
          "num_cand": "U2FsdGVkX18QsOOeytKHdwu60hx1H5GZyjiQJ5kjAiI=",
          "cpf": "U2FsdGVkX1/InhSvtYTCsTqB5MN+/vSHn2qIissBf3k="
        }, {
          "num_cand": "U2FsdGVkX18uNUbEKKO4DrqyIluVx1kS6NDrn3jkIs4=",
          "cpf": "U2FsdGVkX19n06J1aoZrrjpBMrktZyn9g2uNXiGacQo="
        }, {
          "num_cand": "U2FsdGVkX18Nk/w2hN5J9dpd/+F1nOZ+JuH9oD5xWSg=",
          "cpf": "U2FsdGVkX18m9sEhKkMm6kiQKm0ppC3U9TKX7OSLeec="
        }, {
          "num_cand": "U2FsdGVkX1+IbegEKoND1fAzXBx+2KB1Hp30RRoszjc=",
          "cpf": "U2FsdGVkX19xNzUwj0Xv852olUe2sB+6pnTwuu53tWY="
        }, {
          "num_cand": "U2FsdGVkX1/DdOiKgSDYvGB1KG2e3ske/NmvjHXIUi4=",
          "cpf": "U2FsdGVkX19aIRtQyD9Oti7DjtVqFq+OiyHecgZn7j8="
        }, {
          "num_cand": "U2FsdGVkX18DQhAgiiBa+qSbCaVKRh/fTmQIpGPs+Os=",
          "cpf": "U2FsdGVkX1+R+M8+kJ71cQ3OIuQAJxoDiUcsnGElV/U="
        }, {
          "num_cand": "U2FsdGVkX19RWM2NSEUeO0BrTg9pZOPExemySksHuso=",
          "cpf": "U2FsdGVkX1/My9fWWEz7p5ztGKek5R2NbJ+EhMIPvs4="
        }, {
          "num_cand": "U2FsdGVkX1/GXHfSIPtL9a3NYHdhdJL1swI70LOyX7s=",
          "cpf": "U2FsdGVkX1/xsdEfFwPceqe/br4PvBAdIkqDuuboLUM="
        }, {
          "num_cand": "U2FsdGVkX19FlxP9RxEkAVVhbgsf+l9i9lfY8FM0QQg=",
          "cpf": "U2FsdGVkX19c3jm9h3SwpaZrrpxknGehLAzD0VuodWg="
        }, {
          "num_cand": "U2FsdGVkX1/UqlZweII+YXCi8s7GQ9a6uNn6hbigpnI=",
          "cpf": "U2FsdGVkX18JflqV7IeCsztijdfFEq8HgwVtsFno+jY="
        }, {
          "num_cand": "U2FsdGVkX1+XzibzB6HycZcF7kKKniHGC1IIcA5XuFg=",
          "cpf": "U2FsdGVkX1/6ZnF/NACqfup9EglA/q7y1iqyMbA+tSc="
        }, {
          "num_cand": "U2FsdGVkX19QhkSfsd9E2BMvytym5ZZcNmipwzIamEM=",
          "cpf": "U2FsdGVkX1/Bitpvh367De0sRA+qlOg6Y5OtTjFwg/Y="
        }, {
          "num_cand": "U2FsdGVkX1+zBful/yv76AabuEvBRWRfPun8lkTclBw=",
          "cpf": "U2FsdGVkX18CVoz3SdBrBhj3dXsvy+NMMp5jmudb7fA="
        }, {
          "num_cand": "U2FsdGVkX1/K7cOQI9ehVqpDpmf1qq0DoAHFIWYRllQ=",
          "cpf": "U2FsdGVkX19WY5NYFCvLj+KsIRPs7x630sToz/Ph0UM="
        }, {
          "num_cand": "U2FsdGVkX1/9HMbZLCeQV9hDS4Mw/uz5XQvVeA0MP/8=",
          "cpf": "U2FsdGVkX19wJzs8Tqfr3ZPKVZSkcH8kX/yM+FpJxyg="
        }, {
          "num_cand": "U2FsdGVkX19UwzWY0p9vipOm+Vm7B4EHd4qEORcW/i8=",
          "cpf": "U2FsdGVkX18HfhWCeq+UGRFPRUyiapekEhtPefQQwos="
        }, {
          "num_cand": "U2FsdGVkX19fQrAKjuNIWWZr4pKsK5WP+jnP5jejukY=",
          "cpf": "U2FsdGVkX18FHKekgGgfAytZsQOdhyt3DvuPXqa2d2A="
        }, {
          "num_cand": "U2FsdGVkX19FwIWZkNdV7Vkz4FFIUHaBacqSd5EjX3g=",
          "cpf": "U2FsdGVkX19ZZ9+nzLkoi2SKBDAxo36U7BZbdQ/eLEk="
        }, {
          "num_cand": "U2FsdGVkX1/U0ztvdXgO2VVXpm89G/7+dGSzJHarpWM=",
          "cpf": "U2FsdGVkX18MwHvxDUFk1qMpK6AJ4T0XsTKT7h76+fI="
        }, {
          "num_cand": "U2FsdGVkX18AgATTXVvEMXzQoMU7eMTifBWn5xSxwls=",
          "cpf": "U2FsdGVkX18eO+9983A5NaHix+0NES1HxBSNxiaUO4c="
        }, {
          "num_cand": "U2FsdGVkX18p+LsbfkSBNr/J7MLK9Byz6N9Woq6kAYA=",
          "cpf": "U2FsdGVkX1/35Y68SEzhgFmHAoDw/jNCwzz4tnGamz4="
        }, {
          "num_cand": "U2FsdGVkX1+OCLAdvo6/il8m1uQu1y1SJgAn6Dky93M=",
          "cpf": "U2FsdGVkX18T0y6n5DOiQ3fcr2CCXFFNkZcZks1E6xE="
        }, {
          "num_cand": "U2FsdGVkX19DOTpjk8B+VgFbNbbemaOrGaSz5IF1T7c=",
          "cpf": "U2FsdGVkX1+u2pI5lOmgHrFxHpPi7bZyxLE7lwYKZWU="
        }, {
          "num_cand": "U2FsdGVkX19qBQFN6IPTQExK/sSExlXOUP/mH1aiPS8=",
          "cpf": "U2FsdGVkX1/Te8UEQFcnkQT3iP4EGX/WbY1WtqxH/rc="
        }, {
          "num_cand": "U2FsdGVkX19rBV83DAv77UkoS7+ijdS0FwWGJWomfvc=",
          "cpf": "U2FsdGVkX199ty3l60Hc6kpa/B7Eb2il8GKdbJ+SIQ0="
        }, {
          "num_cand": "U2FsdGVkX183PBjmR5CUV9gGvfRq3SEY3zIBG4iujHQ=",
          "cpf": "U2FsdGVkX18wVelloJKtpFku1pQp8TA/ag/4cxEDRAA="
        }, {
          "num_cand": "U2FsdGVkX1+gn7L4Drqjpmtlt0Cabgopi4weimLf5qM=",
          "cpf": "U2FsdGVkX1/eRfc5uef/gB0i4GbMCFxtOZpmuj4Pb9s="
        }, {
          "num_cand": "U2FsdGVkX197aYkGiXJjVQ6J8n5TfhjW5MsTw830wu8=",
          "cpf": "U2FsdGVkX1/OvpTYavLNtWR2YIlwZd7nuQJwT7uD65M="
        }, {
          "num_cand": "U2FsdGVkX1/6HWqFwqOwTZAjB3ybvWP3PRSHARhqCYk=",
          "cpf": "U2FsdGVkX1/P0UFQ4/KF6MP7i89bYRykTK5v0Zmf8FM="
        }, {
          "num_cand": "U2FsdGVkX18FL0tclADTOVQ5jXMnu47Kmhsb+iv3cx8=",
          "cpf": "U2FsdGVkX1/hnQ07Pq3gjJ9Bw8UxkNFL+brBpPp93EA="
        }, {
          "num_cand": "U2FsdGVkX1+687lR8zSKD6QmeYRCDnqFRSHFfD5S5VU=",
          "cpf": "U2FsdGVkX1/qZ9kAfGq1hucQFPXDf2wyXPLYhYiYmXw="
        }, {
          "num_cand": "U2FsdGVkX18PtbkkQeDYqXPIRmYoL5rKgD4KgH2WeIw=",
          "cpf": "U2FsdGVkX1/piPtkM1EitXv3k3FBQ0+Wb1LpEpq3kCU="
        }, {
          "num_cand": "U2FsdGVkX1+tagJt4y/X4kcR1KOdVaASBWcFcmgXNW8=",
          "cpf": "U2FsdGVkX19AmKU1tRLWE2rcNpyUPKMhSaykXGNk42c="
        }, {
          "num_cand": "U2FsdGVkX18xY/Wspxmy3iBv4Pdo6iuU6CE84fNJBzU=",
          "cpf": "U2FsdGVkX1+Ks1/8vUn89TgCjvhNbY9QoyeGzRD1Lug="
        }, {
          "num_cand": "U2FsdGVkX1//S/jYTpe9Gig00sRVhp4a6LqgHuxMcEg=",
          "cpf": "U2FsdGVkX18fdYD5L1iINx4yrFbCjLD112ZxMr3+eGw="
        }, {
          "num_cand": "U2FsdGVkX1/atT+dd+6OvX+0J2N123dvH6vCa039B28=",
          "cpf": "U2FsdGVkX19afuwk70X3Ctm1/uxXJFEqyrUtEUXGPCA="
        }, {
          "num_cand": "U2FsdGVkX19ZMZ/PETmX66NT5Qx2dRMjJ54TZmWvV1c=",
          "cpf": "U2FsdGVkX1+Sog7MLEWqdP0FgHRzkyOm+Fde7lWEBh4="
        }, {
          "num_cand": "U2FsdGVkX1+1grzcDMJN08zc7OrE2FbahXlTlQevD4k=",
          "cpf": "U2FsdGVkX1/PEk55AdqR1GGvTWjxnZF1tlZZNf52YYA="
        }, {
          "num_cand": "U2FsdGVkX19sU4EYa1rqeB8BEMHy5JN67+N7YeThr9s=",
          "cpf": "U2FsdGVkX1+PZr1+JJyt7fuKn5VWMeIVzVwado1mD4c="
        }, {
          "num_cand": "U2FsdGVkX18jciMbjtt4S3faktlQkbWZsfTNp1vkaxs=",
          "cpf": "U2FsdGVkX1/QK4MZKp6HFY6DtyDqyjtwGCIC6kjjGDI="
        }, {
          "num_cand": "U2FsdGVkX19PRxQ4W3029dkIRlRD9E5ftUK8M6JYDEI=",
          "cpf": "U2FsdGVkX1+JIggcuEyc3tyxaY5DMHQOAO2gg7etxpw="
        }, {
          "num_cand": "U2FsdGVkX19jaOMOLQIaKzXj247NJLEptU5BX6IEzuM=",
          "cpf": "U2FsdGVkX19+rMm67a4odRQDp/ZF/aKPCpbfYVnBpUw="
        }, {
          "num_cand": "U2FsdGVkX19kpYzwN2S8uV09ahkr09Laxi+DlgqsFS8=",
          "cpf": "U2FsdGVkX1+t6dUIOIjwJm+oyrc/3SqyGydGqHionkQ="
        }, {
          "num_cand": "U2FsdGVkX18lMopAoTrN1uMEMXrr4F0bkLDX80IYuK4=",
          "cpf": "U2FsdGVkX1/Ea29SSlt+H+6HKDZbMnGQBWMtYC7XYLg="
        }, {
          "num_cand": "U2FsdGVkX1/agufaylspKDUtPVvf9OBD7nWgcKFdubU=",
          "cpf": "U2FsdGVkX1837W+9ZfamKoxDReUhOixuc7FdY+fGjz0="
        }, {
          "num_cand": "U2FsdGVkX19PXIWDtBLU+AgAG9OZr3it2yTVFJ7lCew=",
          "cpf": "U2FsdGVkX1/O4MZZe6w2tV+3dVV4MORFRvzzGXaOMnk="
        }, {
          "num_cand": "U2FsdGVkX19HFFLAy3yel51zE/cDDihxn/ntFeaNXVI=",
          "cpf": "U2FsdGVkX188PrGqkKbYnU8AJeHOVri05S4d2zqKedQ="
        }, {
          "num_cand": "U2FsdGVkX1/c44KiC0PIEM7SGYjYgMPMYRO0NzzAJmI=",
          "cpf": "U2FsdGVkX18IavD5S7Cp9YMICFFma3v7e1e7XpIiREA="
        }, {
          "num_cand": "U2FsdGVkX19pIeqva7Fa/HsIf+hMiVJ2GsWiQtDOFWs=",
          "cpf": "U2FsdGVkX1/odTcx4lfD+O6pi/+DbEOE+z4EXU3O5OY="
        }, {
          "num_cand": "U2FsdGVkX19ZVmVO/kX9857MTX9Wy1UrM3n9W3ARubs=",
          "cpf": "U2FsdGVkX1+P5NW3AqpLXLfbRI9kJdKShSbaJ2vezJE="
        }, {
          "num_cand": "U2FsdGVkX19mCGYzxqN/MGGy/cIUE2pYgiSCy/JoUp4=",
          "cpf": "U2FsdGVkX18J2C02gv3rMgw03R9yc/Jk4We5dRCBN4E="
        }, {
          "num_cand": "U2FsdGVkX1+hE3Hmm69pEycWxIiIuIcodnBEassbQKA=",
          "cpf": "U2FsdGVkX194OFLwHcMwtMJBDji/MTl6EfMOGtPNne0="
        }, {
          "num_cand": "U2FsdGVkX1/CptPpjXoJ4SipnUHkguKgzPk4ZZrLUvA=",
          "cpf": "U2FsdGVkX1/j+Mg+0wWL51j6lejoNbNosma16crMWEY="
        }, {
          "num_cand": "U2FsdGVkX18EibapC6dxxm8e468ma9LpwpKV50PAlJ8=",
          "cpf": "U2FsdGVkX1/PI8Y9lXr0mzansn1gwsnwvma8g+LfydU="
        }, {
          "num_cand": "U2FsdGVkX19eNCFQm4NzVCjNF3EdW54RSYwaMW6/Cpw=",
          "cpf": "U2FsdGVkX19No5jYV3gbYZSOkNHDARbwz15V4uMRTZg="
        }, {
          "num_cand": "U2FsdGVkX1+WVGOZJPk/3hqFMv6UxX1PdiAPUd35z/I=",
          "cpf": "U2FsdGVkX19k0ZZ/9h9zRFdpj7TloHKctnoV+yiFPZY="
        }, {
          "num_cand": "U2FsdGVkX180Ol5BdxGOqdsTTOhb82urEYOqk3eDU1U=",
          "cpf": "U2FsdGVkX18l6CnKoArOcOsdQLcyJ3120bKyEEq/Jhw="
        }, {
          "num_cand": "U2FsdGVkX1/dcgmHgPA/Z9VvPjaPqIgKoY3qFfUNfXA=",
          "cpf": "U2FsdGVkX1/2a7Eype0TUMdzWc9pUcksSTzqpNEI/5Y="
        }, {
          "num_cand": "U2FsdGVkX19FXryVwzV+PAlvVgISAnWs1xZE+mXFk4s=",
          "cpf": "U2FsdGVkX180GJAgXt8mimHafRwrdeMuz7ZgmI1Jj9E="
        }, {
          "num_cand": "U2FsdGVkX1/TJV5vehsXlIk8L+tOaXwljgFbUNwS/8w=",
          "cpf": "U2FsdGVkX19EYWs06fKeVMps/FwFmytprRygvYVIhDc="
        }, {
          "num_cand": "U2FsdGVkX1+upAgi8VI/JwG8jACAYuXeN22JH6lI/dg=",
          "cpf": "U2FsdGVkX1/TQFIAJjhNd0O2ikiPpx8A8eA5rDiJDyA="
        }, {
          "num_cand": "U2FsdGVkX18v5+Ui2r37OcGOy7J4NXInNpgCqe93Myk=",
          "cpf": "U2FsdGVkX1/6oABZJ5smfsIDeHMdZUDrCgRjbV+g+Rk="
        }, {
          "num_cand": "U2FsdGVkX19enNVy/m2U1Nbd8MpoMRM6G+BD+W2bAYI=",
          "cpf": "U2FsdGVkX1/scViDwgRfEjQowvbhWnT343+t8bM82zo="
        }, {
          "num_cand": "U2FsdGVkX1/aTZtEX14ZXjtI6M/6PcDPsNpLmZcQgCg=",
          "cpf": "U2FsdGVkX19l0ZjJFMiT3fHlfx1IMCSMrzX19IY62tE="
        }, {
          "num_cand": "U2FsdGVkX1+nMPpBHi29ZNEP/icddVLuxoN+50pyRjY=",
          "cpf": "U2FsdGVkX1/x7vPrFaVAix2qEQ6DaRLItmiFVaUf0uA="
        }, {
          "num_cand": "U2FsdGVkX1+bu437hqYHJnML81VdKJpuCadHnFPZLoA=",
          "cpf": "U2FsdGVkX1+1PGCmy5fHhxG8opDTphNjqJxxhep/Wtk="
        }, {
          "num_cand": "U2FsdGVkX19tu6csG4OVoc5l5R3bVKQRZR3ovWk0No4=",
          "cpf": "U2FsdGVkX1+oRcxvn2/QDGgd+bwtADT2bjti3nnirSA="
        }, {
          "num_cand": "U2FsdGVkX18IMIVUTMOF2iYWoAzu8XZgYwht/oTONeQ=",
          "cpf": "U2FsdGVkX18JPP1m8OhdWStSUBnvQDupil03+auH+AY="
        }, {
          "num_cand": "U2FsdGVkX19SoYbXOSvplYEVGOit64UQR8/mc4tpf6g=",
          "cpf": "U2FsdGVkX1+Y9ssGL4OOGDWzuvUeySuOE/nQTQ4nwhA="
        }, {
          "num_cand": "U2FsdGVkX19MLVAl9gNXcsgOU/mp4J/suBOyHNDi+FA=",
          "cpf": "U2FsdGVkX1+mb+lZteKmwHIAqG8bElgWJVCXvDbVcTU="
        }, {
          "num_cand": "U2FsdGVkX1+RSMt4f9lRcN8wmVp5fc35QYgq6kYsxwQ=",
          "cpf": "U2FsdGVkX1+DUzDJm5CCpQu8I7SKWJkOUzZ6eTqzadI="
        }, {
          "num_cand": "U2FsdGVkX19RjSkQprt7/d/aUIyoS3MYpIlYzpidYEY=",
          "cpf": "U2FsdGVkX1+HHVVlYoKzWHXeT3gcQQihVm4AsgjUpbc="
        }, {
          "num_cand": "U2FsdGVkX1/IAMmSsmEaOLRvsqxpzqlUO9bonQJlA8Q=",
          "cpf": "U2FsdGVkX1+2d8x7K7Un88DqWOuSsJXZv3FH/Jjgu/Q="
        }, {
          "num_cand": "U2FsdGVkX18ebh13Sb/UxeBP69MHyA3o/6zpGrIQSv8=",
          "cpf": "U2FsdGVkX19VhrrkQgc30RCpBhyeQt47jHmZwDuBdgw="
        }, {
          "num_cand": "U2FsdGVkX18Yv7Wmian5J27vJb6BCJPscQP5nVIfG4k=",
          "cpf": "U2FsdGVkX1/gvASIzz0Bj4E8jUgr8Ocr7FiAvd609Xg="
        }, {
          "num_cand": "U2FsdGVkX1+4s3dGPItBv6jqdFxAESSBojG4VE+Iwps=",
          "cpf": "U2FsdGVkX1+c8IfmhsarTwo6M5QMg9J/cBUCtPedYa0="
        }, {
          "num_cand": "U2FsdGVkX19BsLCq2cZ3reY+9fIqP4CX9McuvK76GJo=",
          "cpf": "U2FsdGVkX18bbKC6bwYIfCDJpio/zIyftikRLfjjcv0="
        }, {
          "num_cand": "U2FsdGVkX1/qaO42d8EY1aTJKZnwLd93AVOk5Xr8MCo=",
          "cpf": "U2FsdGVkX1+I7MLXIUBFePo5CJ5/FHcNSWayETk+PO8="
        }, {
          "num_cand": "U2FsdGVkX19ZDs+GcLSOSfCSq15xRjZjzC5M7ndQxmY=",
          "cpf": "U2FsdGVkX1/0vmnKaUD7OYnsXdR8IDl6vZioL4bsjr8="
        }, {
          "num_cand": "U2FsdGVkX1/NtWO4JGG8xoT8q68uhSoXg1e4xRQ5Nws=",
          "cpf": "U2FsdGVkX18xa6ZlyDDpfV4rGcA8PZkodpTQI7L5vBM="
        }, {
          "num_cand": "U2FsdGVkX1/P6PKzaK6q762+qBh+B6NAphNpRGE/34k=",
          "cpf": "U2FsdGVkX1//8zzJUolC62N4vqNO/B2XNVntJr4RQaU="
        }, {
          "num_cand": "U2FsdGVkX19wsIatnTc+zbxpzp0++227h1GvUqT8WzM=",
          "cpf": "U2FsdGVkX1/qqKWXyN0ayj457p3WjzCZvz0c20/Z7bg="
        }, {
          "num_cand": "U2FsdGVkX1+d6xlTKCdFOPTZrK7mPlxcXJcQxlnnpfE=",
          "cpf": "U2FsdGVkX19IIfjMYIT/Ik/2snJecLDNxmHgwPyYMaw="
        }, {
          "num_cand": "U2FsdGVkX1+zX/HCl0F8kIx/mOyNLDqVLXA6t/eOqAE=",
          "cpf": "U2FsdGVkX1/uOCTNaTVY8gM827rkiSMJZLFY6q3k/zU="
        }, {
          "num_cand": "U2FsdGVkX1+QMyAEy0Y/kZS2s22K7PsnQFyF1bX23Yw=",
          "cpf": "U2FsdGVkX1/3shwVhQgFRKGx7scJslC9c0GEQAuqpkA="
        }, {
          "num_cand": "U2FsdGVkX18uHqdh1D2/4qXw3drUzTOU2CJycDrbNPc=",
          "cpf": "U2FsdGVkX1/5DHQSfBuzSNEAfE7WB3t8Zkbw6wzP3jg="
        }, {
          "num_cand": "U2FsdGVkX18E4LqpB2e5dD4fhkhJIPbnaSSO0TLffKY=",
          "cpf": "U2FsdGVkX18K5AFhlQhpNRqKIkY/i1RefMJz+fJYdfg="
        }, {
          "num_cand": "U2FsdGVkX1+oHADTzyB8ASv3sIgvcejVEagWnVdGDPU=",
          "cpf": "U2FsdGVkX19QY3cCcHwfc9Ywo9nfWwZteVzlZErdgGA="
        }, {
          "num_cand": "U2FsdGVkX18G3B2GSmIjs/O/PNvMBLUMRcDhNikwPWg=",
          "cpf": "U2FsdGVkX1+vl1C+Pm+OWsKsml3WcxUCH9TkDKGGjfY="
        }, {
          "num_cand": "U2FsdGVkX18EBp0uSWvsmeaJzKHhDwpshfP4mNjzzuI=",
          "cpf": "U2FsdGVkX1+xtA5gUWOhzP3KXmryiUeutUDTlBTxjY8="
        }, {
          "num_cand": "U2FsdGVkX1/o8Ov3DSlrQYIY3cikwe7duseg0ThYogM=",
          "cpf": "U2FsdGVkX18gBIo6TXkbIe5YtDvGmB98BEEQvUAP3tQ="
        }, {
          "num_cand": "U2FsdGVkX1+UJ+9ChudQzDfPzTIx7Cxkgx84t9Ua2lc=",
          "cpf": "U2FsdGVkX1/lpuOYeeyqXnTk9B5VMMSZ2+ChU3HmYRA="
        }, {
          "num_cand": "U2FsdGVkX18skVP+T6srpBIpJWVPhqQQZgDhDmf66dM=",
          "cpf": "U2FsdGVkX19PeX0HowJEDPRO8ip/r8X9V5N7T/or/vs="
        }, {
          "num_cand": "U2FsdGVkX1+wgDcBR3iF9lJJH08r4GIhCL2v77ybluA=",
          "cpf": "U2FsdGVkX18e310Hb90/WwZhlykKnwh3YziTfJo5Whw="
        }, {
          "num_cand": "U2FsdGVkX198nk/k1xFNkJXgghCpwyEAVhwDoTyjbzo=",
          "cpf": "U2FsdGVkX18zqHoB+KcTJAPVjG+RJaJaQfbJ/Nxh9+U="
        }, {
          "num_cand": "U2FsdGVkX18UKVSHQxpstP39wWRrNSzotGUbit5Dzng=",
          "cpf": "U2FsdGVkX1/SxiF7XvWsFrM5FGE7n0Y8pl6jQA9A8/o="
        }, {
          "num_cand": "U2FsdGVkX1+CzLNmP3MBeI5fD9K3gjGUBvwdWhdJh+k=",
          "cpf": "U2FsdGVkX1/qPpvbQxNbYhEChBSbKDh/MOf7qGDFn54="
        }, {
          "num_cand": "U2FsdGVkX1/Knhm9dFeNnJfo+LRgWT5KVxlB+Ne6E8E=",
          "cpf": "U2FsdGVkX18OwE0KMgUls991jmQ7iHJV19xRwigbCcw="
        }, {
          "num_cand": "U2FsdGVkX1+VcMJg/PwL4oVNf1+g3jrCbpK6SvTtb8I=",
          "cpf": "U2FsdGVkX18S29frEXO3KcOey3PC7/MaKceOQ0WoN48="
        }, {
          "num_cand": "U2FsdGVkX19sRjiReh+VzcXUJN7B3pqjZwo7bVyfVSo=",
          "cpf": "U2FsdGVkX19OZpFdqEudTDza25isSkJTmPGCwnGd/qA="
        }, {
          "num_cand": "U2FsdGVkX1/XMiqpGgYWmBBnOPRtsr4ZKnpTdbAHwsU=",
          "cpf": "U2FsdGVkX18cTBWq7m/QQ+F+frEFqQA3kG4RZYhGuMQ="
        }, {
          "num_cand": "U2FsdGVkX19S0oQtyP7IISNKdnM0ih3l6lzn3Dg/dMs=",
          "cpf": "U2FsdGVkX19ajP0KJa1KRLcDBO/jNHaDTIroj9nZSs8="
        }, {
          "num_cand": "U2FsdGVkX18Qffuh49WF4oaP0YClIBf6FvtCTXUtpRY=",
          "cpf": "U2FsdGVkX1+SVp1a0ezHvRm+zlaNUTsMKLhuHRt9Gx4="
        }, {
          "num_cand": "U2FsdGVkX1/+ZFqS3pb+P1XL+Z4glx9EqbpPyvr56Sc=",
          "cpf": "U2FsdGVkX1+dXDRPsK3Poov/8QlVovgqe3OZd7vIbkQ="
        }, {
          "num_cand": "U2FsdGVkX19NA7EDSOaNwB2GCWvezGklYhMjgMrvSDY=",
          "cpf": "U2FsdGVkX18Cq4mbnSCWWYdpjRoagiXtlrNfm0QYvXk="
        }, {
          "num_cand": "U2FsdGVkX19ckw1QseA0HcJ79NV182XetltArkDIUFY=",
          "cpf": "U2FsdGVkX19ReK0e1GMF1YGOySYqEMSt9O5eVy6iTow="
        }, {
          "num_cand": "U2FsdGVkX19jwJtmUMTPoF2nC0tzHWTcLtMefKHOjUs=",
          "cpf": "U2FsdGVkX1/xYR9RohFSOU7ISgg2HfMoUXAG03zt/ok="
        }, {
          "num_cand": "U2FsdGVkX1+pVSoINNAlcJtuTtMvURcmmahVJQ6BW/A=",
          "cpf": "U2FsdGVkX1/0CBx2MlM8GwQCVQLmYkuKf7WPGGTOEpw="
        }, {
          "num_cand": "U2FsdGVkX19y/VaKvu/WVUAWhlKxZ6fP5HRlBEkFaSU=",
          "cpf": "U2FsdGVkX1+GJtBIvPfbp+fj6r6yFB8RapsZ8lo/VUA="
        }, {
          "num_cand": "U2FsdGVkX1+tvtGQ2zAAFCaVVf6zNXwsySvQHJa8MCI=",
          "cpf": "U2FsdGVkX19zZLAPIeRSaehMZE17LKVZBPQ4h5i1iEs="
        }, {
          "num_cand": "U2FsdGVkX1/BdsOaDR1cMAk70rp0ORmhSwv/wXOEkmc=",
          "cpf": "U2FsdGVkX18NJ+T01y523M0oADPW5zj0dCc37iBdoR8="
        }, {
          "num_cand": "U2FsdGVkX18AOYyqBG+uJ9SVG83IVyrFMBuUSrsdKEQ=",
          "cpf": "U2FsdGVkX18EggkhEQlY+oT1JcsW4qIUVHZwLyRJCFk="
        }, {
          "num_cand": "U2FsdGVkX1/OJsEfIFoD6t55wkPxGMKf/ye8T2ow3dA=",
          "cpf": "U2FsdGVkX1+Kjerun3NVjfoVj/RMD/BaDufbmOx+GIg="
        }, {
          "num_cand": "U2FsdGVkX18L01QAJIEL7lyU0zDjn7oScgxzWuo9E7s=",
          "cpf": "U2FsdGVkX18wKm6Ay39Dut6Bn46PHND4i/vfssVP+IA="
        }, {
          "num_cand": "U2FsdGVkX1/D+2/l3+bSJ89iZFf9QeukZDX/wzvwZ4w=",
          "cpf": "U2FsdGVkX19lD3irQFEdhdXSIQk1R3IkzlL/KFjcP0E="
        }, {
          "num_cand": "U2FsdGVkX1/EOAhVDeRsxIyyd2WwoKDGXZpOr5fFlBE=",
          "cpf": "U2FsdGVkX1+xXKBqiaJt+7eLwjc92gzWK48tuTkpvkM="
        }, {
          "num_cand": "U2FsdGVkX182NeJmzpuSy5+vaolnsT8F6J/3b75nb0g=",
          "cpf": "U2FsdGVkX1+pyVLVpVApaLbsl+41w5Q3J3F71U/w404="
        }, {
          "num_cand": "U2FsdGVkX1981D2y+95YV1yaabjS8AXFFGjdUxZkvVA=",
          "cpf": "U2FsdGVkX19SmGhhdtfa5sdA1T+ZqPIeByVcRA2LGWE="
        }, {
          "num_cand": "U2FsdGVkX18D3GYmeAUzLpEkyJGlnVwBuRkqsR7RpNk=",
          "cpf": "U2FsdGVkX1+6hM5J5V//beg7UnLnCuJLdpxh55FFJ08="
        }, {
          "num_cand": "U2FsdGVkX18Ch8iem+5DAh2qzAAvGSiKTmxaENTdL14=",
          "cpf": "U2FsdGVkX19s/gnzFYPkkum1Zn7nWU550m7FO7Mnrso="
        }, {
          "num_cand": "U2FsdGVkX1+niGaJn22kIpufzvxIeQ7k/vpst3ozDHc=",
          "cpf": "U2FsdGVkX18ixJZqpsxuPIRDELZuNO8nKN7xagBmUko="
        }, {
          "num_cand": "U2FsdGVkX1/YJkkM91gCAcA8At6S0l9Z7ADTq9moTrA=",
          "cpf": "U2FsdGVkX18JienQ6bGj++bxZ52VA93Uz7ELY1trGE0="
        }, {
          "num_cand": "U2FsdGVkX194ifBnyJKwbQ4nLctImeA3SGOsNGiubu4=",
          "cpf": "U2FsdGVkX185hJVUVe+oF26mAWYJ0CfGkK8erSfj8WM="
        }, {
          "num_cand": "U2FsdGVkX1/dxlHzGod8LImhX188EP282rg1zfvk70c=",
          "cpf": "U2FsdGVkX1+1LqYJSpBy9VhBkNM4IVyCbjRdrb/+Wzo="
        }, {
          "num_cand": "U2FsdGVkX19d6mPAUjrLIeKPrHBsxbjXsuMfij1uOHM=",
          "cpf": "U2FsdGVkX1/ddR7MKz5ugPOXsjSxT8prTReB8kbfYB4="
        }, {
          "num_cand": "U2FsdGVkX18hr1jvdUXYJRVaLwBtRpBseDMAyAOb0CY=",
          "cpf": "U2FsdGVkX19Slz89Dm6R806DmwW5d90BJaDkPt/t2is="
        }, {
          "num_cand": "U2FsdGVkX18AGve4HRXAN9ImPKyUXsnVPvpsR8G0J6U=",
          "cpf": "U2FsdGVkX1+U5OCBDJsc8gBIuc2NhUlnpwQZ4FYYs6Q="
        }, {
          "num_cand": "U2FsdGVkX19xOFdF9UTATj4ejQuYKQ3ey5eOd1uDJws=",
          "cpf": "U2FsdGVkX1/bQVuVPcLo32VGHpz8erbzURY6gVBNen8="
        }, {
          "num_cand": "U2FsdGVkX19BCuyQftVixA4aG+Sx3ifHJikv9pjHiQk=",
          "cpf": "U2FsdGVkX1/rMCoJNGLfX+p+5Ul8cTUkd0RoXMnEfbU="
        }, {
          "num_cand": "U2FsdGVkX19bf/Q9Hn3Kr89VVjJ0ok54tjlPbwZ4OU0=",
          "cpf": "U2FsdGVkX1+xGP9n7MAwzoes5Gro3FzF4RJyFISWSG0="
        }, {
          "num_cand": "U2FsdGVkX1/bSr+Pw+Syz96Fe2sXZeVYqVkziBp3l+8=",
          "cpf": "U2FsdGVkX1/m4nIsRu0JIkcely+51VCPlXaE/qJyG9o="
        }, {
          "num_cand": "U2FsdGVkX1+r58dOAXUTqFD+8WHWCIcpof+mNsFZqBU=",
          "cpf": "U2FsdGVkX19AHV4rq0hCo2ftYAXHouBigjNJlLrPs0c="
        }, {
          "num_cand": "U2FsdGVkX1/tjTfnaHv3XHVlWnsbfDV/1XquaGiD2zg=",
          "cpf": "U2FsdGVkX19Qo5VwXaFtNRmlsftfII37ab7WzBKXO8U="
        }, {
          "num_cand": "U2FsdGVkX1/iMbHZOYWkZPDR1heqjjY5/ngO9AWphEs=",
          "cpf": "U2FsdGVkX1/uF7QcOxKXwdRz5ikKg4foSPU45/yrzps="
        }, {
          "num_cand": "U2FsdGVkX19ALCXCQWPssaRJFLO0VW+NVQLiDkOavNE=",
          "cpf": "U2FsdGVkX18xLslsr/3GS60WTH1yWlVetqpiYbQMYh0="
        }, {
          "num_cand": "U2FsdGVkX18QGrkGL4hKCiI6VsMVXMPuKV1WzfyPpPY=",
          "cpf": "U2FsdGVkX1/09tKgtgYrFilEvqLI7v4IdCY39mbo8Bg="
        }, {
          "num_cand": "U2FsdGVkX1+Wb8wa2h9GScd0vfvhdxRHQegqThtYdJc=",
          "cpf": "U2FsdGVkX19yOFTELNoMKZy79kQwE3aSqQ4Su0enuNc="
        }, {
          "num_cand": "U2FsdGVkX18ksQirhrMqSY+lJx5BHBXC7b15wA+eZao=",
          "cpf": "U2FsdGVkX1+us3K28qXaWIlQZnYSG6HfcxDlkIeRet0="
        }, {
          "num_cand": "U2FsdGVkX1/xpe72O0fdS/eT2KkB56uZCpJp/O/o0kA=",
          "cpf": "U2FsdGVkX1/qPyR+crEkV0sLpqvcmAnoHIB1u8RttFQ="
        }, {
          "num_cand": "U2FsdGVkX180pxt/wkbkjYm/V6wV89XgFIJszes01Gs=",
          "cpf": "U2FsdGVkX1/0CNy4S9YxWUIm6HMrkYs44SC9rLN7+5Y="
        }, {
          "num_cand": "U2FsdGVkX1+1wgpwr7deRWSQbuV09iSiEXA/FXDxfnY=",
          "cpf": "U2FsdGVkX19HKKPRZQBdwnVpgaVP5Awflc5h0RSLUco="
        }, {
          "num_cand": "U2FsdGVkX19z5YGugBXSutXkZT+1lCxvuJ4hDLQ0rGI=",
          "cpf": "U2FsdGVkX1/hOwx/zzBLYZ9cwkpjD3jh+2ZluTyiNEA="
        }, {
          "num_cand": "U2FsdGVkX1+uwBIUVmZKSjxoJfvALV6JHniSotVPk+U=",
          "cpf": "U2FsdGVkX1/n2zAV4VmSywyLRxNCkrxg2ut+MwrybQQ="
        }, {
          "num_cand": "U2FsdGVkX1//iD6B7Er216U9FG8TWEJKDhqRLVFK3ww=",
          "cpf": "U2FsdGVkX18aTrtFtKcDBS03sUGrHg/JSq3B0FVr78I="
        }, {
          "num_cand": "U2FsdGVkX1+EbPz3MV4csJuTtdEOZU2Wzl0JFfS807k=",
          "cpf": "U2FsdGVkX1+YpsC4OqcuJq0By25gTw8V2xpwdQNW93U="
        }, {
          "num_cand": "U2FsdGVkX1+jrsp6J9Z9Uzj1rfNgo2mkJDnaJTWpG/8=",
          "cpf": "U2FsdGVkX19oNalczXkLfshWhGzq0xKwI3FtF9UgUdY="
        }, {
          "num_cand": "U2FsdGVkX18MfT3KgRCx/73o5lM5JGGHcRik3h4RMPE=",
          "cpf": "U2FsdGVkX1/Us6urCB7WWipaTT2GMElmbGngqt4UQzc="
        }, {
          "num_cand": "U2FsdGVkX18h8PlWtzz06etu1Tan2joDSP89IDWJ+GM=",
          "cpf": "U2FsdGVkX19ahLblh8av7pRIGS2RKUtrkKkp8qSW0ME="
        }, {
          "num_cand": "U2FsdGVkX1/GWYYXIb5SjQONq78kybBYVMC0VCsQ+V0=",
          "cpf": "U2FsdGVkX19wuyPhK/VviTslFIi130Th/aHLEpQ1SNc="
        }, {
          "num_cand": "U2FsdGVkX18uTE8dTny4tzfhQ8ON+N8eG8nY20UOvdA=",
          "cpf": "U2FsdGVkX19Y6j+0EL0DSrgHbh2HNCev8bJP6bL5Wio="
        }, {
          "num_cand": "U2FsdGVkX19Su7riVKDd57sl2BjVuPb1eobCU8nZGpI=",
          "cpf": "U2FsdGVkX19WyzAI5+oei77TW3i+QOg9J9HPMChX000="
        }, {
          "num_cand": "U2FsdGVkX1/TjBL3T1RfBUE8q62eWqe8WlLAe9OxIPE=",
          "cpf": "U2FsdGVkX198fE19rIMiO8wWm9mcJFraSVlQMjZJnPs="
        }, {
          "num_cand": "U2FsdGVkX1+wr6qE1wp9+gW3oTTtcPlxh2mqCDAsKuU=",
          "cpf": "U2FsdGVkX1/QtVtaD5pNTt5nZypR1sLWNrZq54RtMbc="
        }, {
          "num_cand": "U2FsdGVkX18OfQrnI2H7psmNAdqcICu0nPlPX7XSSkE=",
          "cpf": "U2FsdGVkX1/5AfTWxyMmMYp8Mtsyk0lvqZcaJ0/uH7s="
        }, {
          "num_cand": "U2FsdGVkX19bPBHsw6d0QfleZkikynL3onECUqbDpdM=",
          "cpf": "U2FsdGVkX19b3IF+2lGMAOp5107xA0gyO5B3A7ASUhQ="
        }, {
          "num_cand": "U2FsdGVkX1+RH8/AgG8/wixnSmzGgVBKoZm2UppsCU0=",
          "cpf": "U2FsdGVkX1/WihiVY354GkEO/no0iYkO7XL8pFMHvuk="
        }, {
          "num_cand": "U2FsdGVkX18F4cOBVmVjwPLK7EZyt9+l/Rcpj8AW1zQ=",
          "cpf": "U2FsdGVkX1+6DYGyJL9ITXivpe00uR5VLuOdDB17e5w="
        }, {
          "num_cand": "U2FsdGVkX19Ev+Kmm6CoMfTXbegOSo2g0kISIxhWxRQ=",
          "cpf": "U2FsdGVkX1+aTLTPbMsdcwDbq03/Sk61v+j364sK/G0="
        }, {
          "num_cand": "U2FsdGVkX193E0EISutm9PLueGDupB9dPZq3qyDQLWM=",
          "cpf": "U2FsdGVkX1+tRwVjvUbDaVzKg67Uea5HjDP3yjPdgps="
        }, {
          "num_cand": "U2FsdGVkX1/U5rLH8+pq+oJ0q5E00MJkDF6qItBhkxQ=",
          "cpf": "U2FsdGVkX1+zWSxJsf1JMpOBRy5v3t7I8XliijN2pXQ="
        }, {
          "num_cand": "U2FsdGVkX1+DSjF6cJ3uP5LzNFcmkjgg4YayEO98or4=",
          "cpf": "U2FsdGVkX19aMqLNYqTsdmVoWKFrxUkpT8ZqaPCaioE="
        }, {
          "num_cand": "U2FsdGVkX1+Yi8L7XgmBP7ho4mK1t6Ya9f1HWKSALv0=",
          "cpf": "U2FsdGVkX1/ZLKLC6Ql4Y4d4rvQ0zIcO8OmqvWZLASU="
        }, {
          "num_cand": "U2FsdGVkX19zzCazrTff/Pa/l0lHxA1Hc6sOGmFAHe8=",
          "cpf": "U2FsdGVkX19HNA2magENStwekm7DM9ucHCCSDF6/4t8="
        }, {
          "num_cand": "U2FsdGVkX19XZMQa1ZUB8uWWN/ijKQIz3YUKZccFRkU=",
          "cpf": "U2FsdGVkX1+R2w2Eg6jDNIarGco6hbk20+7ZiSsB2Hk="
        }, {
          "num_cand": "U2FsdGVkX18ct9OA5i0UKUySnOyQ30qFzpVsALZKxl0=",
          "cpf": "U2FsdGVkX1/01IL/u53s2YsVTEUGJmokLEDWk0TpyY8="
        }, {
          "num_cand": "U2FsdGVkX19QU7aID6DJGecExAxHQmuPrcYEybHSf+A=",
          "cpf": "U2FsdGVkX1/3KmIvZDMdSLTy21QSmqrM8zC5fGeK6nI="
        }, {
          "num_cand": "U2FsdGVkX1+mbDsZ0XYBk5stcaOio2tVtvv8bpRj9DM=",
          "cpf": "U2FsdGVkX19WpW0eE75BUGGeghTRUmZtK5p6bUYMo9M="
        }, {
          "num_cand": "U2FsdGVkX18xffrbu6An+FVyU0Fh9ccpEuo9sVo7qUU=",
          "cpf": "U2FsdGVkX18bcyNLYJL41Iw19hU+WkQqMjfu8FAgzGY="
        }, {
          "num_cand": "U2FsdGVkX1/l7PG1xoeEsLE81xKe7qBJUfAM701JrpQ=",
          "cpf": "U2FsdGVkX1/9V+i3acndVuXy9UZgWpkpogDIstPPfgI="
        }, {
          "num_cand": "U2FsdGVkX1/s7Zs+ATl/Y59UsS+1YszxMBEQSInUGIM=",
          "cpf": "U2FsdGVkX180ajdN1Dt1umJc0/CmCAXd21ya09Tnsk0="
        }, {
          "num_cand": "U2FsdGVkX1/PifL3Keek+k8UEJLWRaVvsffIa/jbfvU=",
          "cpf": "U2FsdGVkX1/807F+YDBKVf3iwLWVWaVOwXpgTV0N0lg="
        }, {
          "num_cand": "U2FsdGVkX18S2tU345mOhb8l3Rgm5dMgjoh+MSCWNOs=",
          "cpf": "U2FsdGVkX18xODiKEEdEH33rGa9XE8082nebu3x3gYg="
        }, {
          "num_cand": "U2FsdGVkX1+74h4ctcxc4dUTmSiwmTqJj5onQpCP7zk=",
          "cpf": "U2FsdGVkX1+Q5KQGC2jMVQxsVSuoiI+bMdhppfr2GJU="
        }, {
          "num_cand": "U2FsdGVkX18+ZWo7VfICL1jrbufiAjSYHPL8UiyJWso=",
          "cpf": "U2FsdGVkX19CdJiylk0rX9xAkNK0MZnHvNqxOKXtN38="
        }, {
          "num_cand": "U2FsdGVkX19YVQQ/FfSiFIFr7H76JpDOwIidkA74Oxs=",
          "cpf": "U2FsdGVkX18FSH+HOFIQvZWrBAbXdH6OueTKd5kCGKs="
        }, {
          "num_cand": "U2FsdGVkX1/yyxbvd/cDuXaxa+BGLMXALhpmYxg8Lug=",
          "cpf": "U2FsdGVkX18lk9qnSGnZWPkoxaU+MziiKHYn3dz627E="
        }, {
          "num_cand": "U2FsdGVkX18Rf1B2UjEiOD3enpxQ7e0K4SOgBPEV2+Y=",
          "cpf": "U2FsdGVkX1/9oz05XLyrSsONcUInAETLOMPMNcw8MY4="
        }, {
          "num_cand": "U2FsdGVkX1+xVeRLqKCAOs2xxWTb1UQZO4i3FdS4Em4=",
          "cpf": "U2FsdGVkX1/HR+/zXpPtDoeMtjdVSWBxo1R7OQHuOmw="
        }, {
          "num_cand": "U2FsdGVkX18zhxe85vINstfOeXSe6CErOH1ijdet/Gg=",
          "cpf": "U2FsdGVkX18vyHja4frhAbFqjJT6EhgXfXiq4R57JUs="
        }, {
          "num_cand": "U2FsdGVkX1+tBgOFXY8lLl13ik8Wa3o0NIhQlZv5FiE=",
          "cpf": "U2FsdGVkX1/JIa9Oht+TIbaf+j0g6fkCimMxlCPDsNE="
        }, {
          "num_cand": "U2FsdGVkX1+393ip2jt+4os1vSUYqe+L8jKSrjDp8IY=",
          "cpf": "U2FsdGVkX1+YyN0fYI6Mn4AkDk2GDcWPkMSBG2mXydU="
        }, {
          "num_cand": "U2FsdGVkX18C5zqRaToL7Hk6qcTYuyDO5iJo1s4DyeA=",
          "cpf": "U2FsdGVkX1+ow2CIMYhEHPDPTWy0ctYeCSqSKodoE10="
        }, {
          "num_cand": "U2FsdGVkX1/ADyruazsrllLetTzA5WRVj8773AbdTy4=",
          "cpf": "U2FsdGVkX1+mGZMu9ojFGDBUZzo85tZePr5ry3sH+mQ="
        }, {
          "num_cand": "U2FsdGVkX182lCJb4EkgrMfzouk3OHQBCU3sqLQLPPg=",
          "cpf": "U2FsdGVkX18veM83F6ORRYRe8tzhEU4kYa8iZj8Fw1g="
        }, {
          "num_cand": "U2FsdGVkX1+63efcxNti0RTdSQZLxp2i9XD7Dozvvyo=",
          "cpf": "U2FsdGVkX1/s8z2rQt8t29N/yn9ucQSOOc1/dpnJFjs="
        }, {
          "num_cand": "U2FsdGVkX1/JkLOBtjWBEy7IaoePdHpZ+XaUNL7uUpU=",
          "cpf": "U2FsdGVkX18gR71RG4GM18l56Bvn6Mro0TB2wZxdtDc="
        }, {
          "num_cand": "U2FsdGVkX191hw+of5y95yx9XgXxEnQlDbuB018sM/E=",
          "cpf": "U2FsdGVkX19+GVqHTaQwp/KL/88BjZ/OJ1JOVKNgGOI="
        }, {
          "num_cand": "U2FsdGVkX18R3JBz9+MX8IxMRXQPbVR/w/v+x/u9QzI=",
          "cpf": "U2FsdGVkX18VUL00VcopOOgFdExH3bxgdqGBuUmCK6s="
        }, {
          "num_cand": "U2FsdGVkX1806W9gAll5VOo3PYzrdqfUF21aOuuJqjM=",
          "cpf": "U2FsdGVkX199L2Vr9OBAaTRrgtqHFk+mtP2fEIo/fEA="
        }, {
          "num_cand": "U2FsdGVkX19SrLweA3xZYIHxMzJ3owLMclEOxa0iKa8=",
          "cpf": "U2FsdGVkX1/yxA3lafY4ekHa1Z9lCEyxzyJsCmh/O0I="
        }, {
          "num_cand": "U2FsdGVkX190JiDAR2g+z4BujiR136/dE4G7fTngzg0=",
          "cpf": "U2FsdGVkX189q0+AAO/ocQMMaZCeTXfqEi9l/odFuRw="
        }, {
          "num_cand": "U2FsdGVkX1/KCO0Kubt1u4yH/97DuDh+/4NzCfsE47g=",
          "cpf": "U2FsdGVkX1/eWybKvP6peSG44L62s8vJmRIbTNYdgNE="
        }, {
          "num_cand": "U2FsdGVkX18IR7FkIC6dkmT0js1II14mtNtP6yjhQf4=",
          "cpf": "U2FsdGVkX1//XlahsRpyAnDp+amgWdKSL6XEupD5JOg="
        }, {
          "num_cand": "U2FsdGVkX19m4bUSqqxmGUngqu5mjLKBXpYt2eCod+0=",
          "cpf": "U2FsdGVkX1+3rKNZinawa+L79LaiB0UeLNAzGAVtUeo="
        }, {
          "num_cand": "U2FsdGVkX1/OM1tJwbtqCGAlTVFNVJ322qbISz7bICE=",
          "cpf": "U2FsdGVkX1+trqwbqGIJXx5E6OkHpDBe6Axgkx1OoKY="
        }, {
          "num_cand": "U2FsdGVkX19IqKwmNbUq7b9nMFsr5rW6HuN7SbWMs9Y=",
          "cpf": "U2FsdGVkX18O4iwtM8C1wWOmLveYgM9G0Sr8HK9u6O0="
        }, {
          "num_cand": "U2FsdGVkX19mZG9r74f6OYzD43DiTRSW9F8ar/6oCHQ=",
          "cpf": "U2FsdGVkX19BFa7bE2LK7gPm1dAmJpe+XEmA0vMF5UY="
        }, {
          "num_cand": "U2FsdGVkX19pi0jiiAtdDSoBTrn6TPmkmBsQfsobxGg=",
          "cpf": "U2FsdGVkX19ljbfPpQSTxbR1ZYUBno9f648/ZBk+LEQ="
        }, {
          "num_cand": "U2FsdGVkX192qmwr7mkAtoCrIc6PMnfsZrr7JHLVcbU=",
          "cpf": "U2FsdGVkX193Eaki7rDK3ut7xhZ6Ghq6zG5b3JHss/w="
        }, {
          "num_cand": "U2FsdGVkX1+NAG3cSojKMtcoCW8tdEhpHhdXbejljYo=",
          "cpf": "U2FsdGVkX1/S8QOXhXoGmdVz7mD3xXdamDNGFGWmsbE="
        }, {
          "num_cand": "U2FsdGVkX1/rnrJAbVz+oEpmGb73ajKMOlgORTN/xx4=",
          "cpf": "U2FsdGVkX19zGhCnp8t/DpRQ/BgiHc8UzKJgvGGVL1w="
        }, {
          "num_cand": "U2FsdGVkX19LH9OI7cmg6u4ico6yr3sk3XL+WovUj4E=",
          "cpf": "U2FsdGVkX18KD9t2iXK4X0zMr2kwt7cI2pkCx4RN71E="
        }, {
          "num_cand": "U2FsdGVkX1+6Bu1IY58lwab4yYL17khIl5bTEeJG28o=",
          "cpf": "U2FsdGVkX19/bNNZmq9brFzMIpGvOZbjtI8BwPVmflQ="
        }, {
          "num_cand": "U2FsdGVkX1/uruHKnLNi7BKWLpZZPUBu+SZ4xrKyMQ0=",
          "cpf": "U2FsdGVkX1+eUHp2BHf+5J1rhhalvoNRnQvoyMWze+k="
        }]

      try {

        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2216/rec_isenc_asda/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
